class ConfiguratorBenchlegs {
    cylindo_mapping = {
        'classiclegs-aluminium-#size#': 'CLASSIC-BED-LEGS-ALUMINIUM-#size#',
        'classiclegs-black-#size#': 'CLASSIC-BED-LEGS-BLACK-#size#',
        'classiclegs-copper-#size#': 'CLASSIC-BED-LEGS-COPPER-#size#',
        'cylinderalulegs-black-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-BLACK-ALU-#size#',
        'cylinderalulegs-grey-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-GREY-ALU-#size#',
        'cylinderalulegs-oak-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-OAK-ALU-#size#',
        'cylinderalulegs-wenge-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-WENGE-ALU-#size#',
        'cylinderalulegs-white-alu-#size#': 'CYLINDER-ALYMINIUM-BED-LEGS-WHITE-ALU-#size#',
        'cylinderlegs-oak-#size#': 'CYLINDER-BED-LEG-OAK-#size#',
        'cylinderlegs-wenge-#size#': 'CYLINDER-BED-LEG-WENGE-#size#',
        'lodlegs-black-#size#': 'LOD-BED-LEGS-BLACK-#size#',
        'lodlegs-brass-#size#': 'LOD-BED-LEGS-BRASS-#size#',
        'lodlegs-chrome-#size#': 'LOD-BED-LEGS-CHROME-#size#',
        'segellegs-aluminium-#size#': 'SEGEL-BED-LEGS-ALUMINIUM-#size#',
        'reling-black': 'RELING-BED-LEGS-BLACK-13',
        'reling-brass': 'RELING-BED-LEGS-BRASS-13',
        'reling-chrome': 'RELING-BED-LEGS-CHROME-13',
        'benchlegs-black': 'BENCH LEG - KOL BLACK',
        'benchlegs-aluminium': 'BENCH LEG - KOL CHROME',
        'benchlegs-brass': 'BENCH LEG - KOL BRASS',
        'cylinderlegs-walnut-#size#': 'CYLINDER-BED-LEG-WALNUT-#size#'
    }

    constructor() {
        this.id = 'benchlegs';
        this.cache = {};
        this.items = {};
        this.buyables = {};
        
        this.selectors = [
            'benchlegs'
        ];

        this.sizes = bed_configuration.sizes;

        configurator.addSelectorItem(this.id);
    }

    async refresh(selector) {
        await this.loadItems();
        this.populateItems();
    }

    isValidSelector(selector) {
        return this.selectors.includes(selector);
    }

    setupListeners() {
    }

    async loadItems() {
        const size = '90x180';
        const size_arr = size.split('x');
        let width = parseInt(size_arr[0]);
        const is_double = width > 140 ? true : false;

        // Check if already loaded
        if (Object.keys(this.cache).length > 0) {
            return;
        }

        // Load Legs
        const products = await configurator.loadProductData('configurator-bench-legs', [], [], true); // Load images
        this.cache['products'] = {};
        
        for (const product of products) {
            for (const variant of product.variants) {
                if (variant.option1 != '13 cm' && variant.option1 != '12.5x12.5' && variant.option1 != '14 cm') { continue; }
                if (variant.option2 == null) { continue; }

                // Skip variants with price 0 when e-commerce is enabled
                if (variant.price == 0 && configurator.enable_ecommerce == true) { continue; }

                const variant_id = variant.id.replace('gid://shopify/ProductVariant/', '');
                let lbl = ""; //[variant.option1, variant.option2, variant.option3].join(" ");
                let variant_handle = ""; //product.handle + '-' + variant.title.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                const skus = [];
                const ids = [];
                let price = 0;


                const is_double = (size_arr[0] >= 160);
                lbl = `4 x ${variant.option2} ${variant.option1}`;
                variant_handle = product.productid + '-' + variant.option2.toLowerCase().replace(/\s/g, '').replace(/\//g, '-');

                skus.push(variant.sku);
                ids.push(variant_id);
                price = variant.price;
                if (is_double) {
                    skus.push(variant.sku);
                    ids.push(variant_id);
                    price = 2 * price;
                }

                this.cache['products'][variant_handle] = {
                    'id': variant_handle,
                    'label': lbl,
                    'skus': skus,
                    'ids': ids,
                    'price': price,
                    'thumbnail': variant.image ? variant.image : product.image, //(product.images.length > 0 ? product.images[0].src: null),
                    'group_by': product.title
                };
            }
        }

        if (!(this.id in configurator.selection)) {
            configurator.selection[ this.id ] = Object.keys(this.cache['products']).shift();
        }
    }

    populateItems() {
        this.items = this.cache['products'];

        configurator.renderSelector(this.id, Object.values(this.items), {
            'thumbnails': true,
            'columns': 3, 
            'allow_none': false
        });
    }

    isSoldOut() {
        const item = this.items[ configurator.selection.benchlegs ];
        
        if (item && item.available) return false;
        return true;
    }

    getPriceData(priceData) {
        const item = this.items[ configurator.selection.benchlegs ];
        
        if (item != null) {
            priceData.total += item.price ?? 0;
            priceData.skus.push(...item.skus);
            priceData.ids.push(...item.ids);
        }
    }

    getCylindoSpecs(specs) {
        // ============== Translate Legs config ==============
        if (configurator.selection.benchlegs != null) {
            let key = configurator.selection.benchlegs;

            // Köl bench legs without size in Cylindo
            if (key in this.cylindo_mapping) {
                specs.features['LEGS'] = this.cylindo_mapping[key];
                return;
            }

            // Bed legs with size 13 cm in Cylindo
            key = key + '-#size#';
            if (key in this.cylindo_mapping) {
                specs.features['LEGS'] = this.cylindo_mapping[key].replace('#size#', '13');
                return;
            }
        }
    }
}
